import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

class PAUTCoverForm extends Form {
	state = {
		data: {
			scopeOfWork: '',
			visualExamination: '',
			phasedProcedure: '',
			mpExamination: '',
			utProcedure: '',
			ndtQualification: '',
			nonDestructiveTesting: '',
			drawingNo: '',
			circuteNo: '',
			processPiping: '',
			upstreamProcessPiping: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		scopeOfWork: Joi.string().min(5).required().label('Scope Of Work'),
		visualExamination: Joi.string()
			.min(5)
			.required()
			.label('Visual Examination'),
		phasedProcedure: Joi.string()
			.min(3)
			.required()
			.label('Phased Array Procedure For Weld Scan'),
		mpExamination: Joi.string()
			.min(3)
			.required()
			.label('Magnetic Particle Examination'),
		utProcedure: Joi.string()
			.min(3)
			.required()
			.label('Ultrasonic Testing Procedure for Flaw Detection'),
		ndtQualification: Joi.string()
			.min(3)
			.required()
			.label('Qualification of NDT Personnel'),
		nonDestructiveTesting: Joi.string()
			.min(3)
			.required()
			.label('Non Destructive Testing'),
		drawingNo: Joi.string().required().label('Drawing / P&ID Number'),
		circuteNo: Joi.string().required().label('Circute Number'),
		processPiping: Joi.string()
			.min(3)
			.required()
			.label('Process Piping Design'),
		upstreamProcessPiping: Joi.string()
			.min(3)
			.required()
			.label('Upstream Process Piping Welding and Inspection'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'scopeOfWork',
							label: 'Scope of work',
							placeholder: 'Enter Scope of Work',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'visualExamination',
							label: 'Visual Examination',
							placeholder: 'Enter Visual Examination',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'phasedProcedure',
							label: 'Phased Array Procedure For Weld Scan',
							placeholder: 'Enter Phased Array Procedure For Weld Scan',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'mpExamination',
							label: 'Magnetic Particle Examination',
							placeholder: 'Enter Magnetic Particle Examination Value',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'ndtQualification',
							label: 'Qualification of NDT Personnel',
							placeholder: 'e.g. ASNT SNT-TC-1A',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'utProcedure',
							label: 'Ultrasonic Testing Procedure for Flaw Detection',
							placeholder: 'e.g. ERHA-NGER-9B-KQNDT-00-39085',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'nonDestructiveTesting',
							label: 'Non Destructive Testing',
							placeholder: 'Enter Non Destructive Testing Value',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'drawingNo',
							label: 'Drawing / P&ID Number',
							placeholder: 'Enter Drawing / P&ID Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'circuteNo',
							label: 'Circute Number',
							placeholder: 'Enter Circute Number',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'processPiping',
							label: 'Process Piping Design',
							placeholder: 'Enter Process Piping Design',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'upstreamProcessPiping',
							label: 'Upstream Process Piping Welding and Inspection',
							placeholder:
								'Enter Upstream Process Piping Welding and Inspection',
						})}
					</div>
				</div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default PAUTCoverForm;
